export const productRandomListSelector = store => store.productRandom.list;
export const isLoadingProductRandomSelector = store => store.productRandom.isLoading;
export const errorProductRandom = store => store.productRandom.error;
